import { StarFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { Yellow5 } from "styles/antTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconStarFilled: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <StarFilled
            {...props}
            type="star"
            style={{ ...props.style, color: props.fill ?? Yellow5 }}
        />
    );
};
